import React, { useEffect, useState } from 'react';
import {
  Popover,
  Box,
  Typography,
  Button,
  Stack,
  useMediaQuery,
  CircularProgress,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getApiCall, postApiCall } from 'api/apiService';
import {
  GET_MASTER_NOTIFICATION_SETTINGS,
  STORE_AGENT_NOTIFICATION_SETTINGS,
} from 'constant/app.config';

const SettingIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3238 2.81529C17.5563 3.06271 17.5942 3.4424 17.6702 4.2018C17.8147 5.64737 17.887 6.37015 18.3408 6.62487C18.4099 6.66368 18.4835 6.69414 18.5598 6.71559C19.0608 6.85633 19.623 6.39636 20.7473 5.47641C21.338 4.99315 21.6333 4.75151 21.9726 4.74092C22.0267 4.73923 22.0807 4.74193 22.1343 4.74899C22.4709 4.79329 22.7407 5.06311 23.2804 5.60275L24.3972 6.71958C24.9368 7.25924 25.2067 7.52906 25.251 7.86564C25.258 7.91922 25.2607 7.97329 25.259 8.02731C25.2484 8.36662 25.0068 8.66196 25.251 9.25263L24.5235 9.25264C23.6036 10.377 23.1436 10.9392 23.2843 11.4402C23.3058 11.5165 23.3362 11.5901 23.375 11.6592C23.6298 12.113 24.3526 12.1853 25.7982 12.3298C26.5576 12.4058 26.9373 12.4437 27.1847 12.6762C27.2241 12.7132 27.2604 12.7533 27.2933 12.7962C27.5 13.0655 27.5 13.4471 27.5 14.2103V15.7899C27.5 16.5529 27.5 16.9344 27.2934 17.2037C27.2605 17.2467 27.2241 17.2869 27.1846 17.3239C26.9372 17.5563 26.5576 17.5942 25.7983 17.6702C24.353 17.8147 23.6304 17.887 23.3756 18.3405C23.3667 18.4098 23.3062 18.4835 23.2847 18.56C23.1442 19.0608 23.604 19.6229 24.5237 20.747C25.0069 21.3375 25.2484 21.6327 25.2591 21.972C25.2608 22.0261 25.2581 22.0803 25.251 22.134C25.2067 22.4705 24.9369 22.7402 24.3974 23.2797L23.2804 24.3967C22.7408 24.9363 22.471 25.2062 22.1344 25.2505C22.0808 25.2575 22.0267 25.2602 21.9727 25.2585C21.6334 25.2479 21.3381 25.0063 20.7474 24.523C19.623 23.6031 19.0608 13.31 18.5599 23.2839C18.4835 23.3053 18.41 23.3358 18.3408 23.3746C17.8871 23.6293 17.8148 24.3522 17.6702 25.7979C17.5942 26.5575 17.5563 26.9374 17.3237 27.1848C17.2868 27.2241 17.2467 27.2604 17.2039 27.2932C16.9346 27.5 16.5529 27.5 15.7895 27.5H14.2103C13.4471 27.5 13.0655 27.5 12.7962 27.2933C12.7533 27.2604 12.7132 27.2241 12.6762 27.1847C12.4437 26.9373 12.4058 26.5576 12.3298 25.7982C12.1853 24.3526 12.113 23.6298 11.6592 23.3751C11.5901 23.3362 11.5166 23.3058 11.4402 23.2844C10.9392 23.1436 10.377 23.6036 9.25259 24.5236C8.6619 25.0069 8.36655 25.2485 8.02723 25.2591C7.97323 25.2608 7.91917 25.2581 7.8656 25.251C7.52901 25.2067 7.25918 24.9369 6.71951 24.3972L5.60271 23.2804C5.06305 22.7408 4.79322 22.4709 4.74893 22.1344C4.74188 22.0808 4.74918 22.0267 4.74086 21.9727C4.75145 21.6334 4.99309 21.3381 5.47638 20.7474C6.39635 19.623 6.85633 19.0608 6.71558 18.5598C6.69413 18.4834 6.66368 18.4099 6.62486 18.3408C6.37015 17.887 5.64736 17.8147 4.20179 17.6702C3.4424 17.5942 3.06271 17.5563 2.81529 17.3238C2.7759 17.2868 2.73957 17.2467 2.70667 17.2038C2.5 16.9345 2.5 16.5529 2.5 15.7897L2.5 14.2104C2.5 13.4471 2.5 13.0654 2.70674 12.7961C2.7396 12.7533 2.77588 12.7132 2.8152 12.6763C3.06264 12.4437 3.44241 12.4058 4.20194 12.3298C5.6478 12.1852 6.37073 12.1129 6.62542 11.659C6.66416 11.59 6.69457 11.5166 6.716 11.4403C6.85687 10.9393 6.39678 10.3769 5.4766 9.25227C4.99316 8.66141 4.75144 8.36598 4.74092 8.02656C4.73924 7.97266 4.74193 7.91872 4.74896 7.86525C4.79321 7.52857 5.06311 7.25866 5.60292 6.71886L6.71957 5.60221C7.25924 5.06254 7.52907 4.79271 7.86565 4.74842C7.91923 4.74137 7.97328 4.73867 8.02729 4.74035C8.36661 4.75094 8.66199 4.99261 9.25275 5.47595C10.377 6.39583 10.9392 6.85577 11.4401 6.71515C11.5165 6.69368 11.5902 6.66318 11.6594 6.62429C12.113 6.36954 12.1853 6.64691 12.3298 4.20163C12.4058 3.4424 12.4437 3.06278 12.6761 2.81539C12.7131 2.77593 12.7533 2.73954 12.7963 2.70659C13.0656 2.5 13.4471 2.5 14.2101 2.5H15.7897C16.5529 2.5 16.9345 2.5 17.2038 2.70667C17.2467 2.73957 17.2868 2.7759 17.3238 2.81529ZM15 20C17.7614 20 20 17.7614 20 15C20 12.2386 17.7614 10 15 10C12.2386 10 10 12.2386 10 15C10 17.7614 12.2386 20 15 20Z"
      fill="#6B6B6B"
    />
  </svg>
);

const ToggleOff = () => (
  <svg
    width="42"
    height="25"
    viewBox="0 0 42 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.459961"
      y="0.370483"
      width="41.54"
      height="24.3705"
      rx="12.1852"
      fill="#DFDFDF"
    />
    <ellipse cx="12.981" cy="12.5557" rx="8.52103" ry="8.86199" fill="white" />
  </svg>
);

const ToggleOn = () => (
  <svg
    width="42"
    height="25"
    viewBox="0 0 42 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.460938"
      width="41.54"
      height="24.3705"
      rx="12.1852"
      fill="url(#paint0_linear_action_popup)"
    />
    <ellipse cx="30.0913" cy="12.1852" rx="8.52103" ry="8.86199" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_action_popup"
        x1="12.7341"
        y1="-1.66162"
        x2="18.2578"
        y2="28.3495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6C2AD2" />
        <stop offset="1" stopColor="#77CFFE" />
      </linearGradient>
    </defs>
  </svg>
);

export default function ActionNotificationSettingPopup({
  open,
  anchorEl,
  Id,
  onClose,
  address,
  propertyId,
}) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const params = useParams();

  const currentPropertyId =
    propertyId || params?.dashboardId || params?.id || params?.propertyId;

  const [fetching, setFetching] = useState(false);
  const [saving, setSaving] = useState(false);
  const [settingsList, setSettingsList] = useState([]);
  const [toggles, setToggles] = useState({});

  const initToggles = (list) => {
    const initialToggles = {};
    list.forEach((option) => {
      initialToggles[option.notificationSettingsId] = {
        portal: Number(option.portal) === 1 || option.portal === true,
        mail: Number(option.mail) === 1 || option.mail === true,
      };
    });

    setToggles(initialToggles);
  };

  const fetchNotificationSettings = async () => {
    if (!currentPropertyId) {
      setSettingsList([]);
      setToggles({});
      return;
    }
    setFetching(true);
    try {
      const url = `${GET_MASTER_NOTIFICATION_SETTINGS}/${currentPropertyId}`;
      const response = await getApiCall(url);
      const dataList =
        response?.data?.masterNotificationSettings ||
        (Array.isArray(response?.data) ? response?.data : []);

      if (dataList && dataList.length > 0) {
        setSettingsList(dataList);
        initToggles(dataList);
      } else {
        setSettingsList([]);
        setToggles({});
      }
    } catch (err) {
      console.error('Error fetching master notification settings:', err);
      setSettingsList([]);
      setToggles({});
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchNotificationSettings();
    }
  }, [open, currentPropertyId]);

  const handleToggle = (notificationSettingsId, channel) => {
    setToggles((prev) => {
      const currentVal = !!prev[notificationSettingsId]?.[channel];
      return {
        ...prev,
        [notificationSettingsId]: {
          ...prev[notificationSettingsId],
          [channel]: !currentVal,
        },
      };
    });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const userDetail = JSON.parse(localStorage.getItem('userDetail') || '{}');
      const currentUserId = userDetail?.userId || 0;

      const notificationSettingsData = settingsList.map((setting) => {
        const toggle = toggles[setting.notificationSettingsId];
        return {
          notificationSettingsId: setting.notificationSettingsId,
          settingCodeId: setting.settingCodeId || setting.mdCodeId,
          settings: setting.settings,
          propertyId: Number(currentPropertyId) || setting.propertyId || 0,
          mail: toggle?.mail ? 1 : 0,
          portal: toggle?.portal ? 1 : 0,
          userId: setting.userId || currentUserId,
          mdCodeId: setting.mdCodeId || setting.settingCodeId,
        };
      });

      const payload = { notificationSettingsData };
      const response = await postApiCall(
        STORE_AGENT_NOTIFICATION_SETTINGS,
        payload
      );

      if (response?.data?.status === 1 || response?.status === 200) {
        Swal.fire({
          title: response?.data?.heading || 'Success',
          text:
            response?.data?.message ||
            'Notification settings saved successfully.',
          icon: 'success',
          confirmButtonText: 'Close',
          confirmButtonColor: '#4CA4D6',
        });
        if (onClose) onClose();
      } else {
        Swal.fire({
          title: response?.data?.heading || 'Error',
          text:
            response?.data?.message || 'Failed to save notification settings.',
          icon: 'error',
          confirmButtonText: 'Close',
          confirmButtonColor: '#4CA4D6',
        });
      }
    } catch (error) {
      console.error('Error saving notification settings:', error);
      Swal.fire({
        title: 'Error',
        text: 'Something went wrong while saving notification settings.',
        icon: 'error',
        confirmButtonText: 'Close',
        confirmButtonColor: '#4CA4D6',
      });
    } finally {
      setSaving(false);
    }
  };

  const handleClosePopup = (event, reason) => {
    if (onClose) onClose(event, reason);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      id={Id}
      onClose={handleClosePopup}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          width: matchessm ? '92vw' : '400px',
          maxWidth: matchessm ? '92vw' : 'none',
          borderRadius: matchessm ? '10px' : '10px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.12)',
          border: '1px solid #EFEFEF',
          ml: matchessm ? 0 : 1.5,
          maxHeight: matchessm ? '85vh' : 'auto',
          overflowY: 'auto',
        },
      }}
    >
      <Box
        sx={{
          padding: matchessm ? '20px 16px' : '28px 24px',
          backgroundColor: 'white',
          boxSizing: 'border-box',
        }}
      >
        {address && (
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 400,
              fontSize: '15px',
              color: '#333333',
              marginBottom: '16px',
            }}
          >
            {address}
          </Typography>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <SettingIcon />
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 700,
              fontSize: '20px',
              color: '#000000',
            }}
          >
            Notification Settings
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            mb: 2,
          }}
        >
          <Box sx={{ width: '42px', textAlign: 'center' }}>
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontWeight: 700,
                fontSize: '15px',
                color: '#000000',
              }}
            >
              App
            </Typography>
          </Box>
          <Box sx={{ width: '42px', textAlign: 'center' }}>
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontWeight: 700,
                fontSize: '15px',
                color: '#000000',
              }}
            >
              Email
            </Typography>
          </Box>
        </Box>

        {fetching ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              py: 4,
            }}
          >
            <CircularProgress size={30} sx={{ color: '#4CA4D6' }} />
          </Box>
        ) : settingsList.length > 0 ? (
          <Stack spacing={2}>
            {settingsList.map((item) => {
              const isAppOn = !!toggles[item.notificationSettingsId]?.portal;
              const isEmailOn = !!toggles[item.notificationSettingsId]?.mail;

              return (
                <Box
                  key={item.notificationSettingsId}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                      fontSize: '15px',
                      color: '#000000',
                    }}
                  >
                    {item.settings}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Button
                      onClick={() =>
                        handleToggle(item.notificationSettingsId, 'portal')
                      }
                      disableRipple
                      sx={{ backgroundColor: 'transparent', minWidth: 0, p: 0 }}
                    >
                      {isAppOn ? <ToggleOn /> : <ToggleOff />}
                    </Button>
                    <Button
                      onClick={() =>
                        handleToggle(item.notificationSettingsId, 'mail')
                      }
                      disableRipple
                      sx={{ backgroundColor: 'transparent', minWidth: 0, p: 0 }}
                    >
                      {isEmailOn ? <ToggleOn /> : <ToggleOff />}
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Stack>
        ) : (
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: '14px',
              color: '#666666',
              textAlign: 'center',
              py: 3,
            }}
          >
            No notification settings available
          </Typography>
        )}

        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 4 }}
        >
          <Button
            onClick={onClose}
            disabled={saving}
            sx={{
              backgroundColor: '#FFFFFF',
              color: '#666666',
              textTransform: 'none',
              fontFamily: 'Poppins',
              fontWeight: 400,
              fontSize: '14px',
              borderRadius: '5px',
              border: '1px solid #DFDFDF',
              padding: '6px 24px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#F5F5F5',
                borderColor: '#CCCCCC',
                boxShadow: 'none',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={saving || fetching}
            sx={{
              backgroundColor: '#4CA4D6',
              color: '#FFFFFF',
              textTransform: 'none',
              fontFamily: 'Poppins',
              fontWeight: 500,
              fontSize: '14px',
              borderRadius: '5px',
              padding: '6px 28px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#3b93c5',
                boxShadow: 'none',
              },
              '&.Mui-disabled': {
                backgroundColor: '#A5D4EF',
                color: '#FFFFFF',
              },
            }}
          >
            {saving ? (
              <CircularProgress size={20} sx={{ color: '#FFFFFF' }} />
            ) : (
              'Save'
            )}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
}
